import { createContext, useContext } from 'react';

const FormOptionalLabelContext = createContext('Optional');
export const FormOptionalLabelProvider = FormOptionalLabelContext.Provider;
export const useFormOptionalLabel = () => useContext(FormOptionalLabelContext);
